import { c as _c } from "react/compiler-runtime";
import { Card } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
interface SummarySectionSkeletonProps {
  hasTotal?: boolean;
}
function SummarySectionSkeleton(t0) {
  const $ = _c(6);
  const {
    hasTotal: t1
  } = t0;
  const hasTotal = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className="bg-accent flex items-center justify-between px-4 py-2 lg:px-6" data-slot="summary-section-header"><Skeleton className="bg-border h-4 w-28" /><Skeleton className="bg-border h-4 w-20" /></header>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-0 px-4 py-3 lg:px-6">{[1, 2, 3].map(_temp)}</div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== hasTotal) {
    t4 = hasTotal && <footer className="bg-accent flex items-center justify-between px-4 py-2 lg:px-6" data-slot="summary-section-footer"><Skeleton className="bg-border h-4 w-24" /><Skeleton className="bg-border h-4 w-16" /></footer>;
    $[2] = hasTotal;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <Card className="gap-0 overflow-hidden p-0">{t2}{t3}{t4}</Card>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(i) {
  return <div key={i} className="border-border flex items-center justify-between border-b py-3 last:border-b-0"><Skeleton className="bg-border h-4 w-32" /><Skeleton className="bg-border h-4 w-16" /></div>;
}
export { SummarySectionSkeleton };